import React, { useRef } from "react";
import ScrollToTop from "../../components/scroll-to-top";
import SEO from "../../components/seo";
import PageBanner from "../../containers/global/page-banner";
import Footer from "../../layouts/footer";
import Header from "../../layouts/header";
import Layout from "../../layouts/index";
import BODData from "../../data/board-of-directors.json";
import BODContainer from "../../containers/about-us/board-of-directors";

const BoardOfDirectorsPage = () => {
    const contRef = useRef(null);
    const handleScrollToHeader = () => {
        console.log("scrllheader", contRef);
        if (contRef.current) {
            console.log("scrllheader2");
            // Adjust scrolling to account for the height of the small div
            const headerPosition = contRef.current.offsetTop;
            const divHeight = 0; // Adjust this if your div's height changes
            window.scrollTo({
                top: headerPosition,
                behavior: "smooth",
            });
        }
    };
    return (
        <React.Fragment>
            <Layout>
                <SEO title="Board Of Directors | NeoGrowth - Lending simplified. Growth amplified." />
                <div className="wrapper">
                    <Header
                        onPressSkipButton={() => {
                            handleScrollToHeader();
                        }}
                    />
                    <PageBanner
                        title="Board Of Directors"
                        excerpt=""
                        image="/images/banner/page/leadership.png"
                    />

                    <BODContainer contRef={contRef} data={BODData} />

                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default BoardOfDirectorsPage;
